import { createAsyncThunk } from '@reduxjs/toolkit';
import ContentReviewAPI from './contentReviewApi';

const extractError = (err, fallback) =>
  err?.response?.data?.error?.message || err?.response?.data?.detail || err.message || fallback;

export const submitReviewRequestThunk = createAsyncThunk(
  'contentReview/submit',
  async (payload, { rejectWithValue }) => {
    try {
      return await ContentReviewAPI.submitReview(payload);
    } catch (err) {
      return rejectWithValue(extractError(err, 'Failed to submit review request'));
    }
  }
);

export const fetchMyReviewRequestsThunk = createAsyncThunk(
  'contentReview/fetchMine',
  async (_, { rejectWithValue }) => {
    try {
      return await ContentReviewAPI.fetchMine();
    } catch (err) {
      return rejectWithValue(extractError(err, 'Failed to load your review requests'));
    }
  }
);

export const fetchAdminReviewQueueThunk = createAsyncThunk(
  'contentReview/fetchAdminQueue',
  async (status, { rejectWithValue }) => {
    try {
      return await ContentReviewAPI.fetchAdminQueue(status);
    } catch (err) {
      return rejectWithValue(extractError(err, 'Failed to load the review queue'));
    }
  }
);

export const decideReviewRequestThunk = createAsyncThunk(
  'contentReview/decide',
  async ({ reviewId, decision, admin_reason }, { rejectWithValue }) => {
    try {
      return await ContentReviewAPI.decide(reviewId, { decision, admin_reason });
    } catch (err) {
      return rejectWithValue(extractError(err, 'Failed to record the decision'));
    }
  }
);
